(() => {
  const roots = document.querySelectorAll('[data-etchly-custom-hat]');
  if (!roots.length) return;

  document.documentElement.classList.add('ech-product-configurator-page');
  document.querySelectorAll('.cc-header--sticky').forEach((node) => node.classList.remove('cc-header--sticky'));
  document.querySelectorAll('store-header[data-is-sticky]').forEach((node) => node.removeAttribute('data-is-sticky'));

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const HEX_OUTER = 'M50 2 Q51 2 52 2.5 L95 14 Q98 15 98 18 L98 52 Q98 55 95 56 L52 68 Q50 69 48 68 L5 56 Q2 55 2 52 L2 18 Q2 15 5 14 L48 2.5 Q49 2 50 2 Z';
  const HEX_STITCH = 'M50 7 Q51 7 52 7.5 L90 18 Q93 19 93 22 L93 48 Q93 51 90 52 L52 63 Q50 64 48 63 L10 52 Q7 51 7 48 L7 22 Q7 19 10 18 L48 7.5 Q49 7 50 7 Z';

  const ensureRuntimeStyles = () => {
    if (document.getElementById('ech-mockup-refinement-styles')) return;
    const style = document.createElement('style');
    style.id = 'ech-mockup-refinement-styles';
    style.textContent = `
      html.ech-product-configurator-page .cc-header--sticky{position:relative!important;top:auto!important}
      .ech-preview-card{position:relative!important;top:auto!important;align-self:stretch!important;background:transparent!important;border:0!important;box-shadow:none!important;padding:0!important}
      .ech-preview-head{padding:20px 20px 16px;background:var(--warm);border:1px solid var(--border);border-radius:20px}
      .ech-preview-stage{position:sticky!important;top:12px;z-index:12;margin:12px 0!important;border:1px solid var(--border);box-shadow:0 14px 36px rgba(17,17,17,.12)}
      .ech-preview-disclaimer{margin:0!important;padding:16px 18px 8px;background:var(--warm);border:1px solid var(--border);border-bottom:0;border-radius:16px 16px 0 0}
      .ech-summary{padding:0 18px 16px;background:var(--warm);border:1px solid var(--border);border-top:0;border-radius:0 0 16px 16px}
      .ech-mobile-bar{display:none!important}
      .ech-order-step .ech-add-btn{display:flex!important;width:100%!important}
      .ech-patch-preview{position:absolute;isolation:isolate}
      .ech-patch-preview.is-stitched{border:0!important}
      .ech-inset-stitch{position:absolute;z-index:1;pointer-events:none;inset:7%;border:2px dashed #111;display:none}
      .ech-patch-preview.is-stitched .ech-inset-stitch{display:block}
      .ech-patch-preview.ech-shape-rectangle .ech-inset-stitch{border-radius:2px}
      .ech-patch-preview.ech-shape-rounded .ech-inset-stitch{border-radius:13px}
      .ech-patch-preview.ech-shape-circle .ech-inset-stitch{border-radius:50%}
      .ech-patch-preview.ech-shape-oval{border-radius:50%!important}
      .ech-patch-preview.ech-shape-oval .ech-inset-stitch{border-radius:50%}
      .ech-patch-preview.ech-shape-square .ech-inset-stitch{border-radius:2px}
      .ech-logo-placeholder,.ech-logo-preview{position:relative;z-index:3}
      .ech-patch-preview.ech-shape-hexagon{background:transparent!important;clip-path:none!important;border-radius:0!important;box-shadow:none!important;overflow:visible}
      .ech-patch-preview.ech-shape-hexagon .ech-inset-stitch{display:none!important}
      .ech-hex-surface{position:absolute;inset:0;width:100%;height:100%;z-index:0;overflow:visible;filter:drop-shadow(0 3px 4px rgba(0,0,0,.18))}
      .ech-hex-fill{fill:var(--patch-bg)}
      .ech-hex-stitch{fill:none;stroke:#111;stroke-width:1.55;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2.8 2.2;vector-effect:non-scaling-stroke;display:none}
      .ech-patch-preview.is-stitched .ech-hex-stitch{display:block}
      .ech-shape-grid .ech-hex-icon{width:52px;height:32px;display:block;overflow:visible}
      .ech-shape-grid .ech-hex-icon path{fill:#ba7b47}
      @media(max-width:980px){
        .ech-layout{row-gap:0!important}
        .ech-preview-card{display:contents!important}
        .ech-preview-head{margin-bottom:12px}
        .ech-preview-stage{grid-column:1;margin:0 0 12px!important;top:8px}
        .ech-summary{margin-bottom:22px!important}
      }
      @media(max-width:640px){
        .ech{padding-bottom:0!important}
        .ech-order-step .ech-add-btn{display:flex!important;width:100%!important;min-height:60px}
      }
    `;
    document.head.appendChild(style);
  };

  roots.forEach((root) => {
    root.querySelector('.ech-progress')?.remove();
    root.querySelector('.ech-shape-grid [data-shape="contour"]')?.remove();
    root.querySelector('.ech-mobile-bar')?.remove();
    ensureRuntimeStyles();

    const hexLabel = root.querySelector('.ech-shape-grid [data-shape="hexagon"]');
    if (hexLabel) {
      const oldIcon = hexLabel.querySelector('i');
      if (oldIcon && !hexLabel.querySelector('.ech-hex-icon')) {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.classList.add('ech-hex-icon');
        svg.setAttribute('viewBox', '0 0 100 70');
        svg.setAttribute('preserveAspectRatio', 'none');
        svg.setAttribute('aria-hidden', 'true');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', HEX_OUTER);
        svg.appendChild(path);
        oldIcon.replaceWith(svg);
      }
    }

    const shapeStepCopy = root.querySelector('[data-step="4"] .ech-step-heading p');
    if (shapeStepCopy) shapeStepCopy.textContent = 'Choose the patch silhouette and stitching you want.';

    root.querySelectorAll('.ech-faq details').forEach((detail) => {
      const summary = detail.querySelector('summary');
      const copy = detail.querySelector('p');
      if (!summary || !copy) return;
      if (summary.textContent.includes('custom patch shape')) {
        summary.textContent = 'What patch shapes can I choose?';
        copy.textContent = 'Choose from Rectangle, Rounded Rectangle, Circle, Oval, Square, or Hexagon. We will confirm the final production treatment during proof review.';
      }
      if (summary.textContent.includes('difference between no visible stitching and black stitching')) {
        copy.textContent = 'No visible stitching keeps the patch face visually clean. Black stitching adds a sewn line inset from the patch edge.';
      }
    });

    const form = root.querySelector('.ech-form');
    if (!form) return;

    const stage = root.querySelector('[data-preview-stage]');
    const hatImage = root.querySelector('.ech-hat-image');
    const patch = root.querySelector('[data-patch-preview]');
    const logoPreview = root.querySelector('[data-logo-preview]');
    const logoPlaceholder = root.querySelector('[data-logo-placeholder]');
    const artworkSummary = root.querySelector('[data-summary-artwork]');
    const uploadInput = root.querySelector('[data-artwork-input]');
    const uploadTitle = root.querySelector('[data-upload-title]');
    const uploadCopy = root.querySelector('[data-upload-copy]');
    const uploadError = root.querySelector('[data-upload-error]');
    const qty = root.querySelector('[data-qty]');
    const unitPrice = Number(root.dataset.unitPrice || 0);
    const currency = root.dataset.currency || 'USD';

    let insetStitch = patch?.querySelector('.ech-inset-stitch');
    if (patch && !insetStitch) {
      insetStitch = document.createElement('span');
      insetStitch.className = 'ech-inset-stitch';
      insetStitch.setAttribute('aria-hidden', 'true');
      patch.prepend(insetStitch);
    }

    let hexSurface = patch?.querySelector('.ech-hex-surface');
    if (patch && !hexSurface) {
      hexSurface = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      hexSurface.classList.add('ech-hex-surface');
      hexSurface.setAttribute('viewBox', '0 0 100 70');
      hexSurface.setAttribute('preserveAspectRatio', 'none');
      hexSurface.setAttribute('aria-hidden', 'true');

      const fill = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      fill.classList.add('ech-hex-fill');
      fill.setAttribute('d', HEX_OUTER);
      hexSurface.appendChild(fill);

      const stitch = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      stitch.classList.add('ech-hex-stitch');
      stitch.setAttribute('d', HEX_STITCH);
      hexSurface.appendChild(stitch);

      patch.prepend(hexSurface);
    }

    const applyStartingReference = () => {
      if (stage) {
        stage.style.aspectRatio = '4 / 5';
        stage.style.background = '#ffffff';
      }
      if (hatImage) {
        hatImage.src = 'https://cdn.shopify.com/s/files/1/0710/4738/1306/files/richardson-112-heather-grey-black-front.jpg?v=1788737405';
        hatImage.alt = 'Richardson 112 Heather Grey / Black front view';
        hatImage.width = 1000;
        hatImage.height = 1250;
        hatImage.style.objectFit = 'contain';
        hatImage.style.objectPosition = 'center';
      }
      const heatherGreyBlack = form.querySelector('[name="properties[Hat Color]"][value="Heather Grey / Black"]');
      if (heatherGreyBlack) heatherGreyBlack.checked = true;
      const reference = root.querySelector('.ech-preview-disclaimer');
      if (reference) {
        reference.textContent = 'Starting reference: Richardson 112 Heather Grey / Black. The default centered rectangle is shown at approximately 3 x 2 in. This visual is for placement guidance; final material, engraving, cut line, and placement are confirmed during proof review.';
      }
    };

    const updateSelectedStyles = () => {
      root.querySelectorAll('.ech-choice-card,.ech-swatch,.ech-patch-color,.ech-shape-grid label,.ech-segmented label').forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        if (input) label.classList.toggle('is-selected', input.checked);
      });
    };

    const updateSummary = () => {
      root.querySelectorAll('[data-summary]').forEach((node) => {
        const name = node.dataset.summary;
        const selected = form.querySelector(`[name="properties[${CSS.escape(name)}]"]:checked`);
        if (selected) node.textContent = selected.value;
      });
    };

    const updatePreview = () => {
      const color = root.querySelector('.ech-patch-color input:checked')?.closest('.ech-patch-color')?.dataset.patchColor || '#b87943';
      const shape = root.querySelector('.ech-shape-grid input:checked')?.closest('label')?.dataset.shape || 'rectangle';
      const stitching = form.querySelector('[name="properties[Stitching]"]:checked')?.value || '';
      const position = 'center';

      patch.style.setProperty('--patch-bg', color);
      patch.className = `ech-patch-preview ech-shape-${shape} ech-pos-${position}`;
      if (stitching === 'Black stitching') patch.classList.add('is-stitched');

      patch.style.top = '50.3%';
      patch.style.left = '50%';
      patch.style.height = 'auto';

      if (shape === 'circle' || shape === 'square') {
        patch.style.width = '32%';
        patch.style.aspectRatio = '1 / 1';
      } else if (shape === 'oval') {
        patch.style.width = '45%';
        patch.style.aspectRatio = '1.75 / 1';
      } else if (shape === 'hexagon') {
        patch.style.width = '41%';
        patch.style.aspectRatio = '1.62 / 1';
      } else {
        patch.style.width = '44%';
        patch.style.aspectRatio = '3 / 2';
      }

      if (hexSurface) hexSurface.style.display = shape === 'hexagon' ? 'block' : 'none';
    };

    const updateTotal = () => {
      const quantity = Math.max(1, Number(qty?.value || 1));
      if (qty && Number(qty.value) < 1) qty.value = '1';
      const formatted = money(unitPrice * quantity, currency);
      root.querySelectorAll('[data-total],[data-button-total],[data-mobile-total]').forEach((node) => {
        node.textContent = formatted;
      });
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) {
        updateSelectedStyles();
        updateSummary();
        updatePreview();
      }
      if (event.target === qty) updateTotal();
    });

    qty?.addEventListener('input', updateTotal);
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      qty.value = String(Math.max(1, Number(qty.value || 1) - 1));
      updateTotal();
    });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      qty.value = String(Math.max(1, Number(qty.value || 1) + 1));
      updateTotal();
    });

    uploadInput?.addEventListener('change', () => {
      const file = uploadInput.files?.[0];
      uploadError.hidden = true;
      uploadError.textContent = '';
      if (!file) {
        uploadTitle.textContent = 'Choose your artwork file';
        uploadCopy.textContent = 'Tap to browse - keep files under 20 MB';
        artworkSummary.textContent = 'Not uploaded yet';
        logoPreview.hidden = true;
        logoPreview.removeAttribute('src');
        logoPlaceholder.hidden = false;
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        uploadInput.value = '';
        uploadError.textContent = 'That file is over 20 MB. Please choose a smaller artwork file.';
        uploadError.hidden = false;
        return;
      }
      uploadTitle.textContent = file.name;
      uploadCopy.textContent = `${Math.max(0.1, file.size / 1024 / 1024).toFixed(1)} MB - tap to replace`;
      artworkSummary.textContent = file.name;
      const previewable = /^image\/(png|jpeg|webp|svg\+xml)$/i.test(file.type) || /\.(png|jpe?g|webp|svg)$/i.test(file.name);
      if (previewable) {
        const url = URL.createObjectURL(file);
        logoPreview.src = url;
        logoPreview.hidden = false;
        logoPlaceholder.hidden = true;
        logoPreview.onload = () => URL.revokeObjectURL(url);
      } else {
        logoPreview.hidden = true;
        logoPreview.removeAttribute('src');
        logoPlaceholder.hidden = false;
      }
    });

    form.addEventListener('submit', (event) => {
      const file = uploadInput?.files?.[0];
      if (!file) {
        event.preventDefault();
        uploadError.textContent = 'Please upload your artwork before adding the hats to your cart.';
        uploadError.hidden = false;
        uploadInput.closest('.ech-upload')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);

    applyStartingReference();
    updateSelectedStyles();
    updateSummary();
    updatePreview();
    updateTotal();
  });
})();